import COLORS from "@/features/shared/widgets/graphs/colors";

/**
 * KNMI warning yellow (`--yellow` in theme.css, same value as the yellow in
 * lib/warning-level.ts). Kept local because the shared graph palette has no
 * yellow, and adding one there would change how legacy line-graph widgets
 * resolve a stored `"yellow"` threshold color.
 */
const KNMI_YELLOW = "#FFED00";

/** The AVA index runs 0–100, so the axis is fixed rather than data-driven. */
export const AVA_INDEX_AXIS_MAX = 100;

/**
 * AVA index severity bands. The index is unitless, so the bar color carries the
 * severity instead of the axis. Bands are ordered ascending and `below` is the
 * exclusive upper bound; the last band covers everything up to the axis max.
 */
export const AVA_INDEX_BANDS = [
  { below: 30, color: COLORS.POINTS.green },
  { below: 40, color: KNMI_YELLOW },
  { below: 50, color: COLORS.POINTS.orange },
  { below: Number.POSITIVE_INFINITY, color: COLORS.POINTS.red },
] as const;

/**
 * Color for one AVA index datapoint. Returns `undefined` for gaps so Highcharts
 * falls back to the series color rather than drawing a miscolored bar.
 */
export function avaIndexColor(value: number | null | undefined): string | undefined {
  if (value === null || value === undefined) return undefined;
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return undefined;
  return AVA_INDEX_BANDS.find((band) => numeric < band.below)?.color;
}
